import { useEffect, useState } from 'react';
import { content } from '../data/content';
import { PRODUCT } from '../data/product';

const LINKS = [
  { href: '#problem', label: content.navProblem, icon: 'fa-circle-question' },
  { href: '#how', label: content.navHow, icon: 'fa-circle-play' },
  { href: '#testimonials', label: content.navReviews, icon: 'fa-comments' },
  { href: '#features', label: content.navFeatures, icon: 'fa-star' },
  { href: '#safety', label: content.navSafety, icon: 'fa-shield-heart' },
  { href: '#faq', label: content.navFaq, icon: 'fa-circle-info' },
];

/**
 * تنقّل سريع بين الأقسام على الجوال.
 *
 * الصفحة طويلة، ومن عنده قلق محدّد («هل يحرق الحرير؟») كان عليه أن يمرّر أربعة
 * أقسام أو يصعد إلى قائمة الهيدر. الوصول إلى الجواب بضغطة يقصّر الطريق إلى
 * الشراء — فكل الروابط داخل الصفحة، لا مخرج منها.
 *
 * موضعه أعلى الشاشة تحت الهيدر لا أسفلها: زرّان دائريان متجاوران فوق شريط
 * الشراء يجعلان الإبهام يتردّد أيّهما يضغط، وأي تردّد أمام زر الشراء خسارة.
 * وأسفل القائمة زر واتساب لمن يريد أن يسأل إنساناً قبل أن يطلب.
 */
export default function SectionNav() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // لا يظهر في الشاشة الأولى: هناك لا يزال أمام الزائر قسم واحد فقط
    const onScroll = () => setVisible(window.scrollY > 600);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // الإغلاق بمفتاح Escape — سلوك متوقّع لأي لوحة منبثقة
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!visible) return null;

  return (
    <div className="lg:hidden">
      {/* طبقة شفافة تلتقط الضغط خارج اللوحة فتغلقها */}
      {open && <button className="fixed inset-0 z-40 bg-z-navy/20" aria-label="إغلاق" onClick={() => setOpen(false)} />}

      <div className="fixed end-3 top-[76px] z-50 flex flex-col items-end gap-2">
        <button
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
          aria-label="التنقّل بين الأقسام"
          className="w-11 h-11 rounded-full bg-z-navy text-white shadow-lg shadow-z-navy/30 flex items-center justify-center transition active:scale-95"
        >
          <i className={`fa-solid ${open ? 'fa-xmark' : 'fa-list-ul'} text-sm`} />
        </button>

        {open && (
          <nav className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden w-52">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-4 py-3 text-sm font-bold text-z-navy border-b border-gray-100 active:bg-z-light"
              >
                <i className={`fa-solid ${link.icon} text-z-red text-xs w-4 text-center`} />
                {link.label}
              </a>
            ))}

            <a
              href={`https://wa.me/${PRODUCT.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-sm font-bold text-white bg-z-green active:bg-z-green/90"
            >
              <i className="fa-brands fa-whatsapp text-base w-4 text-center" />
              {content.navWhatsapp}
            </a>
          </nav>
        )}
      </div>
    </div>
  );
}
